
                    const sheet = new CSSStyleSheet();
                    sheet.replaceSync(":host {\r\n    display: block;\r\n}\r\n\r\n.facet-panel {\r\n    min-width: 200px;\r\n    font-size: .875rem;\r\n}");
                    export default sheet;
                